import m from "mithril";
export default {
    view() {
        return (m("nav", { class: "nav" },
            m("span", null,
                m("a", { href: "https://www.phoenixreisen.com" },
                    m("i", { class: "fas fa-home" }),
                    " Homepage")),
            m("span", null,
                m("a", { href: "https://www.phoenixreisen.com/magazin" },
                    m("i", { class: "fas fa-book-open" }),
                    " Magazin")),
            m("span", null,
                m("a", { href: "https://meinereise.phoenixreisen.com" },
                    m("i", { class: "fas fa-sign-in-alt" }),
                    " Mein Phoenix"))));
    },
};
